<div class="container">
  <div class="wrapper">
    <h1 class="pageTitle">{{ pageTitle }}</h1>
    <div [innerHTML]="selectedDepartment?.extra?.service_page_guidance_text_1"></div>
    <div [innerHTML]="selectedDepartment?.extra?.service_page_guidance_text_2"></div>
    <div [innerHTML]="selectedDepartment?.extra?.service_page_guidance_text_3"></div>
    <hr />

    <div class="row card-row">
      <div class="location-card" *ngFor="let service of servicesList; let i = index">
        <div class="bb-image">
          <div class="service-image" [style.background]="'url(' + service.image?.url + ')'"></div>
        </div>
        <div class="card bg-light mb-4 column" tabindex="-1">

          <div class="card-location-header">
            <h2 class="text-dark">
              <strong>{{ service.name }}</strong>
            </h2>
          </div>

          <p class="mt-2" *ngIf="service?.description">
            <span class="service-description" *ngIf="service?.description" [innerHTML]="service.description">
              <br /></span>
          </p>

          <!-- <p class="mt-2" *ngIf="location?.address">
                        <span *ngIf="location?.address.address1">{{location.address.address1}}, <br /></span>
                        <span *ngIf="location?.address.address2">{{location.address.address2}}, <br /></span>
                        <span *ngIf="location?.address.address3">{{location.address.address3}}, <br /></span>
                        <span *ngIf="location?.address.address4">{{location.address.address4}}, <br /></span>
                        <span *ngIf="location?.address.address5">{{location.address.address5}}, <br /></span>
                        <span *ngIf="location?.address.postcode">{{location.address.postcode}} <br /></span>
                    </p> -->

          <div class="bottom">
            <span *ngIf="!service.permitQuestion">
              <span *ngIf="service?.extra.permits_enabled === 'No'">
                <button tabindex="0" class="btn btn-primary float-right mt-4 btn-panellink"
                  title="Select {{ service.name }}" (click)="selectService(service)">
                  <span><span>Select</span><fa-icon [icon]="faChevronRight"></fa-icon></span>
                </button>
              </span>
              <span *ngIf="service?.extra.permits_enabled === 'Yes'">
                <!-- due to float right these appear onscreen in reverse order -->
                <div class="form-group">
                  <button tabindex="0" class="btn btn-primary float-right mt-4 btn-panellink permit-have-select"
                    title="Select {{ service.name }}" (click)="askQuestion(service)">
                    <span><span>I have a Permit</span></span>
                  </button>

                  <button tabindex="0"
                    class="btn btn-primary float-right mt-4 btn-panellink permit-have-select permit-button-padded"
                    title="Select {{ service.name }}" (click)="amendPermit(service)">
                    <span><span>Renew or Amend a permit</span></span>
                  </button>

                  <button tabindex="0"
                    class="btn btn-primary float-right mt-4 btn-panellink permit-have-select permit-button-padded"
                    title="Select {{ service.name }}" (click)="applyForPermit(service)">
                    <span><span>Apply for a Permit</span></span>
                  </button>

                </div>
              </span>
            </span>
            <span *ngIf="service.permitQuestion">
              <div class="float-right permit-questions">
                <div *ngIf="service.status === 0 || service.status === 1">
                  <div class="form-group">
                    <label for="service.permitQuestion.id">
                      <span aria-hidden="true" class="form-field-required-marker">
                        *</span>
                      <span [innerHTML]="service.permitQuestion.name"></span>
                    </label>
                    <input type="number" class="mt-4 btn-panellink" id="service.permitQuestion.id" class="form-control"
                      [(ngModel)]="service.permitQuestion.answer"
                      [disabled]="service.status !== 0 || service.showContinue" />
                    <div *ngIf="service.permitQuestion.error" class="invalid-feedback">
                      <div role="alert" tabindex="0">Please complete</div>
                    </div>
                    <div *ngIf="service.permitQuestion.apiError" class="invalid-feedback">
                      <div role="alert" tabindex="0">
                        {{ service.permitQuestion.apiError }}
                      </div>
                    </div>
                    <div *ngIf="service.permitQuestion.apiNote" class="invalid-feedback">
                      <div role="alert" tabindex="0" style="color: black" [innerHTML]="service.permitQuestion.apiNote">
                      </div>
                    </div>
                    <div *ngIf="service.permitQuestion.apiSuccess" class="invalid-feedback">
                      <div role="alert" tabindex="0" style="color: #008000">
                        {{ service.permitQuestion.apiSuccess }}
                      </div>
                    </div>
                  </div>
                  <div *ngIf="service.status === 0" class="form-group" style="margin-top: -30px">
                    <button *ngIf="!service.showContinue" tabindex="0" class="btn btn-primary mt-4 btn-panellink"
                      style="margin-right: 20px !important" title="Cancel" (click)="service.permitQuestion = false">
                      Cancel
                    </button>
                    <button *ngIf="service.showContinue" tabindex="0" class="btn btn-primary mt-4 btn-panellink"
                      style="margin-right: 20px !important" title="Cancel" (click)="cancelPermit(service)">
                      Cancel
                    </button>
                    <button *ngIf="!service.showContinue" tabindex="0"
                      class="btn btn-primary mt-4 btn-panellink float-right" title="Check"
                      (click)="checkPermit(service)">
                      Check Permit
                    </button>
                    <button *ngIf="service.showContinue" tabindex="0"
                      class="btn btn-primary mt-4 btn-panellink float-right" title="Check"
                      (click)="selectService(service)">
                      Continue
                    </button>
                  </div>
                </div>

                <div *ngIf="service.status === 1">
                  <div class="form-group">
                    <label for="service.vehicleRegQuestion.id">
                      <span aria-hidden="true" class="form-field-required-marker">
                        *</span>
                      <span [innerHTML]="service.vehicleRegQuestion.name"></span>
                    </label>
                    <input type="text" class="mt-4 btn-panellink" id="service.vehicleRegQuestion.id"
                      class="form-control" [(ngModel)]="service.vehicleRegQuestion.answer"
                      (keydown.space)="$event.preventDefault()" (keydown.spacebar)="$event.preventDefault()"
                      oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()"
                      [disabled]="service.showContinue" />
                    <div *ngIf="service.vehicleRegQuestion.error" class="invalid-feedback">
                      <div role="alert" tabindex="0">Please complete</div>
                    </div>
                    <div *ngIf="service.vehicleRegQuestion.apiError" class="invalid-feedback">
                      <div role="alert" tabindex="0">
                        {{ service.vehicleRegQuestion.apiError }}
                      </div>
                    </div>
                    <div *ngIf="service.vehicleRegQuestion.apiNote" class="invalid-feedback">
                      <div role="alert" tabindex="0" style="color: black"
                        [innerHTML]="service.vehicleRegQuestion.apiNote"></div>
                    </div>
                    <div *ngIf="service.vehicleRegQuestion.apiSuccess" class="invalid-feedback">
                      <div role="alert" tabindex="0" style="color: #008000">
                        {{ service.vehicleRegQuestion.apiSuccess }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group" style="margin-top: -30px">
                    <button *ngIf="!service.showContinue" tabindex="0" class="btn btn-primary mt-4 btn-panellink"
                      style="margin-right: 20px !important" title="Cancel" (click)="cancelPermit(service)">
                      Cancel
                    </button>
                    <button *ngIf="service.showContinue" tabindex="0" class="btn btn-primary mt-4 btn-panellink"
                      style="margin-right: 20px !important" title="Cancel" (click)="cancelReg(service)">
                      Cancel
                    </button>
                    <button *ngIf="!service.showContinue" tabindex="0"
                      class="btn btn-primary mt-4 btn-panellink float-right" title="Check"
                      (click)="checkVehicleReg(service)">
                      Check Vehicle
                    </button>
                    <button *ngIf="service.showContinue" tabindex="0"
                      class="btn btn-primary mt-4 btn-panellink float-right" title="Check"
                      (click)="selectService(service)">
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>